const state = {
    errorCodes: [],
    handler: () => {},
    buisnessErrorHandler: () => {},
    showError403Modal: false,
  };

  const mutations = {
    SET_ERRORCODES: (state, data) => {
      state.errorCodes = data;
    },
    SET_HANDLER: (state, handler) => {
      state.handler = handler;
    },
    HANDLE: (state, error) => {
      state.handler(error);
    },
    SET_BUISNESS_ERROR_HANDLER: (state, handler) => {
      state.buisnessErrorHandler = handler;
    },
    BUISNESS_ERROR_HANDLE: (state, error) => {
      state.buisnessErrorHandler(error);
    },
    SET_ERROR403_MODAL: (state, data) => {
      state.showError403Modal = data;
    }
  };

  const actions = {
    setErrorCodes(context, data) {
      context.commit("SET_ERRORCODES", data);
    },
    setHandler(context, handler) {
      context.commit("SET_HANDLER", handler);
    },
    handleError(context, error) {
      context.commit("HANDLE", error);
    },
    setBuisnessErrorHandler(context, handler) {
      context.commit("SET_BUISNESS_ERROR_HANDLER", handler);
    },
    handleBuisnessErrorError(context, error) {
      context.commit("BUISNESS_ERROR_HANDLE", error);
    }
  };

  var getters = {
    getErrorCodes: (state) => {
      return state.errorCodes;
    },
    getError403Modal: (state) => {
      return state.showError403Modal;
    },
  };

  export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
  };
